(function () {
	angular
		.module('trackeye')
		.controller('UserController', UserController);

	UserController.$inject = ['$state', '$q', 'ModalService', 'LanguageService', 'AccountService', 'UserService', 'ConfigurationService', 'AuthService', 'DeviceService', 'NotificationService'];

	function UserController($state, $q, ModalService, LanguageService, AccountService, UserService, ConfigurationService, AuthService, DeviceService, NotificationService) {
		var vm = this;

		vm.account = AccountService.get();
		vm.accountConfig = vm.account.getConfiguration();

		vm.accountForm = {};
		vm.passwordForm = {};

		vm.languages = LanguageService.getLanguages().map(function (v) {
			return {lang: v, translate: "STR_LANG_" + (v.toUpperCase())}
		});

		vm.timezones = moment.tz.names();
		vm.formats = {
			date: [
				"DD/MM/YYYY",
				"MM/DD/YYYY",
				"D. MMM YY",
				"Do MMM YY"
			],
			time: [
				"HH:mm",
				"h:mmA"
			]
		};

		vm.now = moment();

		var changePasswordModal = ModalService.create('change-password', vm),
			xhrProgressModal = ModalService.create('xhr-progress', vm);

		vm.xhrmodal = {
			title: "STR_XHRMODAL_UPDATING",
			subtitle: "STR_XHRMODAL_UPDATING_DEVICES",
			progress: {
				text: "",
				max: 20,
				value: 0
			}
		};

		vm.openChangePasswordModal = function() {
			changePasswordModal.open();
		};

		// @todo move to migration service
		vm.migrateAccount = function (data) {
			vm.migrateForm.$setValidity('migrationCheck', true);
			if (vm.migrateForm.$valid) {
				UserService.migrateAccount(data).then(function () {
					$state.go('^');
					NotificationService.success('STR_NOTICE_ACCOUNT_WAS_MIGRATED');
				}, function (response) {
					if (response.status === 401) {
						vm.migrateForm.$setValidity('migrationCheck', false);
					}
				});
			}
		};

		vm.isFormFieldsValid = function (formName, fields, submitted) {
			var state = true,
				form = vm[formName];

			if (!form)
				return false;

			for (var i in fields) {
				if (form[fields[i]].$invalid) {
					state = false;
				}
			}

			if (submitted && !form.$submitted)
				return true;

			return state;
		};

		// @todo move to maincontroller
		vm.createAccount = function (formData) {
			if (vm.accountForm.$invalid)
				return;

			setIsLoading(true);
			DeviceService.verifyDevice(formData.device_number, formData.device_code).then(function () {
				vm.accountForm.device_number.$setValidity('invalidDevice', true);
				var config = ConfigurationService.factory('te-account', 'Account information and settings', {
					personal: {street: "",zip: "",town: "",phone: "",phone2: "",image: ""},
					settings: {
						locale: LanguageService.getDefaultLanguage(),
						timezone: "",
						format: {date: "",time: ""}
					}
				});

				LanguageService.setDefaultLanguage();

				UserService.createAccount(formData).then(function (response) {
					AuthService.saveToken({
						token: response.data
					});
					config.save().finally(function () {
						setIsLoading(false);
						ConfigurationService.add(config);
						$state.go("dashboard.main.pages", {page: 'account'});
					});
				}, function (response) {
					setIsLoading(false);
					NotificationService.danger("STR_ERROR_NOTICE_SERVER");
					console.warn(response);
				});
			}, function () {
				// Device is invalid
				setIsLoading(false);
				vm.accountForm.device_number.$setValidity('invalidDevice', false);
			});
		};

		vm.saveAccountData = function () {
			var form = vm.accountForm;

			if (!form.$dirty)
				return;

			var deferred = [],
				account_tz = vm.account.getTimezone(),
				account_lang = vm.account.getLocale(),
				account_locale = LanguageService.getLocaleFromLang(account_lang);

			if (account_tz && (vm.timezones.indexOf(account_tz) == -1)) {
				NotificationService.warning("STR_INVALID_TIMEZONE");
				return;
			}

			if (!LanguageService.isAppUsingLanguage(account_lang)) {
				var devices = DeviceService
					.getOwnedSutDevices()
					.filter(function(device) {
						return device.isActive()
					});

				if (devices.length > 0) {
					xhrProgressModal.open();
					vm.xhrmodal.progress.max = devices.length;

					var device_promise = DeviceService.batchUpdateDevices(devices, {
						locale: account_locale
					}, function(device, xhr) {
						vm.xhrmodal.progress.value++;
						if (!xhr.error) {
							device.setLocale(account_locale);
						} else {
							console.warn(xhr.error)
						}
					}).finally(function() {
						vm.xhrmodal.progress.value++;
						setTimeout(function () {
							vm.xhrmodal.progress.value = 0;
							xhrProgressModal.close();
						}, 500);
					});

					deferred.push(device_promise);
				}
			}

			setIsLoading(true);
			deferred.push(vm.account.save(), vm.accountConfig.save());
			$q.all(deferred).then(function () {
				// Update default language, if udpated.
				if (form.timezone.$dirty)
					moment.tz.setDefault(account_tz);

				form.$setPristine();
				LanguageService.setLanguage(vm.account.getLocale());
				NotificationService.info('STR_NOTICE_ACCOUNT_DATA_UPDATED');
			}, function (data) {
				_.log(data);
				NotificationService.warning('STR_ERROR_NOTICE_SERVER');
			}).finally(function () {
				setIsLoading(false);
			});
		};

		vm.changePassword = function (password) {
			vm.passwordForm.$setValidity('tooShort', true);

			if (!(vm.passwordForm.$dirty && vm.passwordForm.$valid))
				return;

			vm.account.save(password.new).then(function () {
				NotificationService.info("STR_NOTICE_PASSWORD_UPDATED");
				changePasswordModal.close();
			}, passwordXhrError);
			
		};

		vm.passwordRecover = function (password) {
			vm.passwordForm.$setValidity('tooShort', true);

			var token = ($state.params.token),
				token_parts = token.split('.'),
				token_obj = JSON.parse(atob(token_parts[1])),
				email = token_obj.user.email;

			if ( !(vm.passwordForm.$dirty && vm.passwordForm.$valid))
				return;

			AuthService.setAccessToken($state.params.token);
			AccountService.fetch(true).then(function() {
				vm.account.save(password.new).then(function() {
					NotificationService.info("STR_NOTICE_PASSWORD_UPDATED");
					AuthService.logout();
					AuthService.authenticate({username: email, password: password.new}).then(function() {
						$state.go('dashboard.main.pages', {page: 'positions'});
						setIsLoading(false)
					})
				}, passwordRecoverXhrError);
			}, function(resp) {
				if (resp.status === 401) {
					vm.passwordForm.$setValidity('linkExpired', false);
				} else {
					// @todo forward error to backend
					console.error(resp);
					NotificationService.warning("STR_ERROR_NOTICE_SERVER");
				}
			});
		}

		function passwordRecoverXhrError(resp) {
			if (resp.status == 422) {
				vm.passwordForm.$setValidity('tooShort', false);
			} else if (resp.status === 401) {
				vm.passwordForm.$setValidity('linkExpired', false);
			} else {
				// @todo forward error to backend
				console.error(resp);
				NotificationService.warning("STR_ERROR_NOTICE_SERVER");
			}
		}

		function passwordXhrError(resp) {
			if (resp.status == 422) {
				vm.passwordForm.$setValidity('tooShort', false);
			} else {
				// @todo forward error to backend
				console.error(resp);
				NotificationService.warning("STR_ERROR_NOTICE_SERVER");
			}
		}

		function setIsLoading(loading) {
			vm.is_loading = !!loading;
		}

		vm.advancedVisible = false;
		vm.showAdvanced = function() {
			return isDebug() || vm.advancedVisible;
		}
		vm.toggleAdvanced = function() {
			return vm.advancedVisible = !vm.advancedVisible;
		}

		vm.toggleDebugMode = function() {
			var debug = !parseInt(window.sessionStorage.getItem('__te_debug__') || 0,10);
			window.sessionStorage.setItem('__te_debug__', debug ? 1 : 0);
			window.location.reload();
		}
		vm.isDebug = isDebug;
		vm.debugButtonText = function() {
			if (isDebug()) {
				return 'STR_DEBUG_ENABLED';
			}
			return 'STR_DEBUG_DISABLED';
		}
	}
})();